module.exports = __webpack_public_path__ + "static/img/qrcode.2f7ba97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-activity/qrcode.png
// module id = 286
// module chunks = 0